module.exports = __webpack_public_path__ + "img/13_Credits_iPad_L.f2d3b43a.jpg";